import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { unwrap } from '@/lib/result';
import { useSessionStore } from '@/stores/session.store';

import { availabilityRepository } from '../api/availability.repository';
import type { AvailabilitySlot } from '../model/availability';

export const availabilityKeys = {
  all: ['availability'] as const,
  mine: (providerId: string) => [...availabilityKeys.all, 'mine', providerId] as const,
};

export function useMyAvailability() {
  const userId = useSessionStore((s) => s.userId);
  return useQuery({
    queryKey: availabilityKeys.mine(userId ?? 'anon'),
    queryFn: () => unwrap(availabilityRepository.listByProvider(userId as string)),
    enabled: Boolean(userId),
  });
}

export function useSaveAvailability() {
  const queryClient = useQueryClient();
  const userId = useSessionStore((s) => s.userId);
  return useMutation({
    mutationFn: (slots: readonly AvailabilitySlot[]) =>
      unwrap(availabilityRepository.replaceAll(userId as string, slots)),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: availabilityKeys.mine(userId ?? 'anon') });
    },
  });
}
